module.exports = __webpack_public_path__ + "static/logo-ddd29fcccb9a53bbe0371e52cd752783.png";